import customerLogo from 'assets/images/usersManagement/customer-logo.svg';
import inspectorLogo from 'assets/images/usersManagement/inspector-logo.svg';
import localAdminLogo from 'assets/images/usersManagement/local-admin-logo.svg';
import managerLogo from 'assets/images/usersManagement/manager-logo.svg';
import { Roles } from 'enums';

export const chooseAvatarFromRole = (role?: Roles) => {
  if (role === Roles.COMMUNITY_CUSTOMER) return customerLogo;
  if (role === Roles.PROPERTY_CUSTOMER) return customerLogo;
  if (role === Roles.INSPECTOR) return inspectorLogo;
  if (role === Roles.MANAGER) return managerLogo;
  if (role === Roles.LOCAL_ADMIN) return localAdminLogo;
  if (role === Roles.COMPANY_ADMIN) return localAdminLogo;
  if (role === Roles.SUPER_ADMIN) return localAdminLogo;
};

export const chooseTitleFromRole = (role?: Roles) => {
  if (role === Roles.INSPECTOR) return 'Inspector';
  if (role === Roles.LOCAL_ADMIN) return 'Local Admin';
  if (role === Roles.MANAGER) return 'Manager';
  if (role === Roles.PROPERTY_CUSTOMER) return 'Customer';
  if (role === Roles.COMMUNITY_CUSTOMER) return 'Customer';
  if (role === Roles.COMPANY_ADMIN) return 'Company Admin';
  if (role === Roles.SUPER_ADMIN) return 'Super Admin';
};

export const chooseCustomerType = (role?: Roles) => {
  if (role === Roles.COMMUNITY_CUSTOMER) return 'Community';
  if (role === Roles.PROPERTY_CUSTOMER) return 'Property';
};
